<template>
<img src="./road-split.svg" alt="split document icon" />
</template>

<script>
export default {
  name: "SplitDocumentIcon"
}
</script>

<style scoped>

</style>
